import React from 'react';
import { Route, useHistory } from 'react-router-dom';
import { handleRouteAccess } from '../../helpers/RouteHelpers';
import { isInteger } from '../../helpers/validators';

const ProtectedRoute = ({ path, isPageEnabled, action, component }) => {
    const Component = component;
    const history = useHistory();

    const renderedComponent = handleRouteAccess({
        Component,
        isPageEnabled,
        history,
        action,
    });
    return (
        <Route
            exact
            path={path}
            render={({ match }) => {
                const id = match?.params?.id;
                if (id) {
                    if (isInteger(id)) {
                        return renderedComponent;
                    }
                    else history.push('/clients');
                }
                else return renderedComponent;
            }}
        />
    );
};

export default ProtectedRoute;
